mutation SendHeldUpdates($attendeeId: ID!) {
  sendHeldUpdates(input: { attendeeId: $attendeeId }) {
    attendee {
      id
      heldUpdateCount
    }
  }
}
